export function determineStepLimits({ value, min, max, disabled = false, isFloorActionDisabled, isStepDownDisabled, isStepUpDisabled, floorThreshold = 1, }) {
    const isAtFloorThreshold = value === floorThreshold;
    const resolvedFloorActionDisabled = isFloorActionDisabled || value !== floorThreshold || disabled;
    const resolvedStepDownDisabled = isStepDownDisabled || value <= min || disabled;
    const resolvedStepUpDisabled = isStepUpDisabled || value >= max || disabled;
    const stepDownDisabled = isAtFloorThreshold
        ? resolvedFloorActionDisabled
        : resolvedStepDownDisabled;
    return {
        isStepDownDisabled: stepDownDisabled,
        isStepUpDisabled: resolvedStepUpDisabled,
        isFloorActionDisabled: resolvedFloorActionDisabled,
        isAtFloorThreshold,
    };
}
//# sourceMappingURL=determineStepLimits.js.map